import Api from '@/services/api.js';

export default {
  addSite(details) {
    return Api.post('sites/', details);
  },
  getSites(id) {
    if (!!id) {
      return this.getSiteByProject(id)
    } else {
      return this.getAllSites()
    }
  },

  getAllSites() {
    return Api.get('sites/');
  },
  deleteSite(site) {
    return Api.delete(`sites/${site}`);
  },
  updateSite(site) {
    var siteId = site.id;
    return Api.put(`sites/${siteId}`, site);
  },
  getSitesByProject(id) {
    return Api.get('sites/byProject/' + id);
  },
}